// No-op unified plugin stub for remark-math — CopilotKit's react-ui imports
// remarkMath but a customer-service chat doesn't render LaTeX. The real
// plugin pulls katex (~4.4 MB on disk) and mdast-util-math via transitive
// deps. Returning a no-op transformer leaves the markdown AST untouched so
// `$...$` and `$$...$$` pass through as literal text.

export default function remarkMath() {
  return function transformer(_tree: unknown, _file?: unknown) {
    // intentional no-op
  };
}
